import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { selectState } from "../inputSlice";
import { useSelector } from "react-redux";
import { FormatDate, FormatDateShort } from "utils/dateUtils";
import { IConcreteBaseInput } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseInput";
import { FormatNumber } from "utils/numberUtils";

const PrintStateOfInput = () => {
  const memorandumLogo = useMemorandumLogo();
  const { inputs } = useSelector(selectState);

  return (
    <>
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
      </div>
      <h1 className="header-stock">Stanje betonske baze na dan:</h1>
      <div className="date">{FormatDate(new Date().toISOString())}</div>
      <table className="stock-table-size table-header">
        <tbody>
          <tr>
            <th>br. otp. rač</th>
            <th>ime</th>
            <th>dobavljač</th>
            <th>ulaz</th>
            <th>kol ostalo</th>
            <th>datum</th>
          </tr>
        </tbody>
      </table>
      <table className="stock-table stock-table-size table-body">
        <tbody>
          {inputs &&
            inputs.map((item: IConcreteBaseInput) => (
              <tr key={`${item.inputId}`}>
                <td>{item.billOfLandingId}</td>
                <td>
                  <div className="name-container">
                    <div>
                      <label className="name">{item.item.name}</label>
                    </div>
                    <label className="badge">
                      {item.repository.shortName}
                    </label>
                  </div>
                </td>
                <td>{item.supplier.fullName}</td>
                <td>{FormatNumber(item.quantityAmountTotal)}</td>
                <td>
                  <span>
                    <label>{FormatNumber(item.quantityAmountRemaining)}</label>
                    <label>{item.quantityUnit.name}</label>
                  </span>
                </td>
                <td>{FormatDateShort(item.billOfLandingDate)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default PrintStateOfInput;
